(function waitForKonva(){

    if (!window.Konva || !window.Konva.stages.length) {
        setTimeout(waitForKonva, 500);
        return;
    }

    (function () {

        function applyContain() {

            const stages = window.Konva?.stages || [];

            if (!stages.length) {
                return;
            }

            const stage = stages[0];

            stage.find('Image').forEach(node => {

                const img = node.image();
                if (!img) return;

                if (node._containApplied) return;

                const boxW = node.width();
                const boxH = node.height();

                const imgW = img.naturalWidth || img.width;
                const imgH = img.naturalHeight || img.height;

                if (!imgW || !imgH) return;

                const scale = Math.min(
                    boxW / imgW,
                    boxH / imgH
                );

                const newW = imgW * scale;
                const newH = imgH * scale;

                node.width(newW);
                node.height(newH);

                node.x(node.x() + (boxW - newW) / 2);
                node.y(node.y() + (boxH - newH) / 2);

                node._containApplied = true;

                node.getLayer()?.batchDraw();

            });
        }

        applyContain();

        setInterval(applyContain, 1000);

    })();

})();